import { TableContainer, TablePagination, TableHead, TableRow, TableBody, Paper, Table, Grid, useMediaQuery } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { authAtom, tokenAtom } from '../../../../actions/index';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import dayjs from 'dayjs';
import { convertMoney, ORDER_STATUS } from '../../../../utils/utils';
import axios from 'axios';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const OrderTab = ({ username: lead_username }) => {
    const [auth] = useAtom(authAtom);
    const [token] = useAtom(tokenAtom);
    const [total, setTotal] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(30);
    const [page, setPage] = useState(0);
    const [orders, setOrders] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const getBookings = useCallback(() => {
        if (token) {
            axios.post('/accounts/customers/get_customer_orders/', {
                username: lead_username,
                offset: page * rowsPerPage,
                limit: rowsPerPage,
            }, { headers: { Authorization: `Token ${token}` } })
                .then(res => {
                    if (res && res.data) {
                        setOrders(res.data.orders ?? []);
                        setTotal(res.data.total ?? 0);
                    }
                })
                .catch(() => {
                    setOrders([]);
                    setTotal(0);
                });
        }
    }, [token, lead_username, page, rowsPerPage]);

    useEffect(() => {
        getBookings();
    }, [getBookings]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Grid container spacing={2} sx={{zIndex: 5}}>
            <Grid item xs={12}>
                <TableContainer component={Paper} style={{ maxHeight: isMobile ? '70vh' : '60vh', overflow: 'auto' }}>
                    <TablePagination
                        rowsPerPageOptions={[20, 30, 40, 50]}
                        component="div"
                        count={total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Mã đơn</StyledTableCell>
                                {!isMobile && <StyledTableCell>Liệu trình</StyledTableCell>}
                                <StyledTableCell>Số buổi</StyledTableCell>
                                <StyledTableCell>Giá mua</StyledTableCell>
                                <StyledTableCell>Ngày mua</StyledTableCell>
                                {!isMobile && <StyledTableCell>Sale chính</StyledTableCell>}
                                {!isMobile && <StyledTableCell>Sale phụ</StyledTableCell>}
                                {!isMobile && <StyledTableCell>NV Hỗ trợ</StyledTableCell>}
                                {!isMobile && <StyledTableCell>Telesale</StyledTableCell>}
                                <StyledTableCell>Trạng thái</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {orders.map((item) => (
                                <TableRow key={item.id}>
                                    <TableCell>{item.id}</TableCell>
                                    {!isMobile && <TableCell>{item.service_name ?? item.service.name}</TableCell>}
                                    <TableCell>{`${item.completed_booking}/${item.number_of_booking}`}</TableCell>
                                    <TableCell>{`${convertMoney(item.price)}đ`}</TableCell>
                                    <TableCell>{dayjs(item.order_date).format('HH:mm DD/MM/YYYY')}</TableCell>
                                    {!isMobile && <TableCell>{item.sale1 ? item.sale1.full_name : ''}</TableCell>}
                                    {!isMobile && <TableCell>{item.sale2 ? item.sale2.full_name : ''}</TableCell>}
                                    {!isMobile && <TableCell>{item.support_user ? item.support_user.full_name : ''}</TableCell>}
                                    {!isMobile && <TableCell>{item.telesale ? item.telesale.full_name : ''}</TableCell>}
                                    <TableCell>{ORDER_STATUS[item.status]}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};

export default OrderTab;
